import { render, staticRenderFns } from "./Repair.vue?vue&type=template&id=38870b20"
import script from "./Repair.vue?vue&type=script&lang=js"
export * from "./Repair.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports